// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"593":"294cec9a","740":"a8a45994"}[chunkId] + ".css";
};